import { isMobile } from '../../helpers/isMobile';
import { Spine } from '../components/spine';
import { gameConfigurationStore } from '../store/gameConfigurationStore';
import { matricesByGameId } from '../../constants/enumsByGames';

// RU: начало линии, идущей справа налево (линии 11–20), — правый край доски.
const RIGHT_TO_LEFT_LINE_OFFSET_X = () => (isMobile() ? 510 : 870);

// RU: спайны линий выигрыша — по два на каждую линию игры (слева направо и справа налево) — и
//     кости каждой линии по барабанам; плюс надпись респина.
class GameResourcesService {
  allLinesSpine = [];

  allWinLinesBone = [];

  reSpinTextScene = null;

  setReSpinText(spine) {
    this.reSpinTextScene = spine;
  }

  setupAllLine(parentContainer) {
    const { WinningLinesCoordinate } = matricesByGameId[gameConfigurationStore.gameId];
    [...WinningLinesCoordinate, ...WinningLinesCoordinate].forEach((_, i) => {
      const winLine = new Spine({ key: 'winLine' });
      if (i >= WinningLinesCoordinate.length) winLine.x += RIGHT_TO_LEFT_LINE_OFFSET_X();
      this.allLinesSpine.push(winLine);
      parentContainer.addChild(winLine);
    });
    this.allWinLinesBone = this.allLinesSpine.map((el) =>
      el.skeleton.bones
        .filter((bone) => bone.data.name.includes('bone'))
        .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
    );
  }
}

export const gameResourcesService = new GameResourcesService();
